/**
 * @module lib/amazon-web-services
 * @description Store AWS API Gateway endpoint urls and related settings.
 */

import tgamConfig from "config/tgam";

// Financial Reports - binary/pdf
export const AWS_STOCKCALC = `${tgamConfig.env.awsBinaryUrl}/stockcalc-report.pdf`;
export const AWS_VALUENGINE = `${tgamConfig.env.awsBinaryUrl}/valuengine-report.pdf`;
export const AWS_STOCK_REPORTS_PLUS_PDF = `${tgamConfig.env.awsBinaryUrl}/stock-reports-plus.pdf`;

// Newsletter API
export const AWS_RECAPTCHA = `${tgamConfig.env.awsDefaultUrl}/verify-captcha.json`;

// Bookmark APIs
export const AWS_BOOKMARKS_ADD = `${tgamConfig.env.awsBookmarksUrl}/bookmarks/add`;
export const AWS_BOOKMARKS_CHECK = `${tgamConfig.env.awsBookmarksUrl}/bookmarks/check`;
export const AWS_BOOKMARKS_CLEAR = `${tgamConfig.env.awsBookmarksUrl}/bookmarks/clear`;
export const AWS_BOOKMARKS_DELETE = `${tgamConfig.env.awsBookmarksUrl}/bookmarks/remove`;
export const AWS_BOOKMARKS_PAGE = `${tgamConfig.env.awsBookmarksUrl}/bookmarks/page`;
export const AWS_BOOKMARKS_TOTAL = `${tgamConfig.env.awsBookmarksUrl}/bookmarks/total`;
